export default function Poems() {
  return (
    <>
      <p class="poemText">
        <h2>Near Far</h2>
        <br />
        I flew far into the afterworld on a budget airline
        <br />
        For peace, for money, for Western rags
        <br />
        For happiness that couldn’t be lost
        <br />
        For an ending, because I had to leave the beginning behind
        <br />
        I don’t remember who I was in those strange times
        <br />
        Skipping two steps at a time in high heels
        <br />
        Coachmen, lanterns, and a small apartment
        <br />
        Golden leaves, golden hair, glimmers on the Vistula, a farewell
        <br />
        I hadn’t drunk coffee yet, didn’t know the taste of wine
        <br />
        Under the clock, the kookaburra’s brazen laugh like a sneer
        <br />
        Blue leaves, silver hair, a double rainbow in the sky
        <br />I flew so far, and yet so close—from myself to myself
        <br />
        <br />
        <h2>Blisko Daleko</h2>
        <br />
        Wyleciałam tanią linią daleko w zaświaty
        <br />
        Po spokój po pieniądze po zachodnie szmaty
        <br />
        Po szczęście którego nie można byłoby stracić
        <br />
        Po koniec bo początek musiałam zostawić
        <br />
        Nie pamiętam kim byłam w tamtych dziwnych czasac
        <br />
        Przeskakując po dwa schodki na wysokich obcasach
        <br />
        Dorożkarze latarnie i małe mieszkanie
        <br />
        Złote liście złote włosy blaski na Wiśle rozstanie
        <br />
        Jeszcze kawy nie piłam nie znałam smaku wina
        <br />
        Pod zegarem kukaburry bezczelny śmiech jak drwina
        <br />
        Niebieskie liście srebrne włosy podwójna tęcza na niebie
        <br />
        Dolecialam tak daleko i tak blisko od siebie do siebie
        <p class="poemSign">Jolanta Hildebrandt-Mazurek</p>
      </p>
      {/* <h2>Distance</h2>
      <p>
        Night
        <br />
        I shake off the specks
        <br />
        of cool doubt
        <br />
        trembling on the skin like stars
        <br />
        I’ve had enough of this pressure
        <br />
        but I wait
        <br />
        Entrenched
        <br />
        in my post of waiting
        <br />
        I count the minutes and the spider’s thread
        <br />
        the sliding stripes of light
        <br />
        watching from where, to where
        <br />
        this delicate thread runs
        <br />
        and our life together
        <br />
        The clink of a key
        <br />
        a gaze like an arrow on the clock face
        <br />
        too late for conversation…I know
        <br />
        your steps rumble
        <br />
        I pretend to sleep
        <br />
      </p>
      <h2>Oddalenie</h2>
      <p>
        Noc
        <br />
        otrząsam pyłki
        <br />
        chłodnego zwątpienia
        <br />
        drżące na ciele jak gwiazdy
        <br />
        dość mam tego ciśnienia
        <br />
        lecz czekam
        <br />
        Okopana
        <br />
        na stanowisku czekania
        <br />
        liczę minuty i pajęczą nić
        <br />
        ślizgające się prążki światła
        <br />
        wypatrując skąd, dokąd
        <br />
        biegnie ta nić delikatna
        <br />
        i nasze życie we dwoje
        <br />
        Szczęk klucza
        <br />
        wzrok jak strzała na tarczy zegara
        <br />
        za późno na rozmowy…wiem
        <br />
        twoje kroki dudnią
        <br />
        udaję, że śpię
        <br />
      </p>
      <h2>Closeness</h2>
      <p>
        A small window <br />
        always the same <br />
        me, you, the house, the street <br />
        A hurricane <br />
        flexible trees making music <br />
        you fell <br />
        You played at being right <br />
        you lost closeness <br />
        only sand remained in your hands <br />
        So-so <br />
        inside out <br />
        wrapped up <br />
        you this way, me that way <br />
        too tight for us <br />
        tick-tock mint <br />
        taste turned distaste <br />
        I am me <br />
        you are you <br />
        abandoned <br />
        overgrown being <br />
        non-being with me <br />
        with you <br />
        being alone with oneself <br />
      </p>
      <h2>Bliskość</h2>
      <p>
        Małe okno
        <br />
        ciągle to samo
        <br />
        ja, ty, dom, ulica
        <br />
        Huragan
        <br />
        giętkie drzewa wygrywają
        <br />
        upadłeś
        <br />
        Grałeś w rację
        <br />
        przegrałeś bliskość
        <br />
        został piasek w rękach
        <br />
        Jako tako
        <br />
        na opak
        <br />
        opakowani
        <br />
        ty tak, ja siak
        <br />
        przyciasno nam
        <br />
        tik tak miętowy
        <br />
        smak w niesmak
        <br />
        ja to ja
        <br />
        ty to ty
        <br />
        opuszczone
        <br />
        zapuszczone bycie
        <br />
        niebycie ze mną
        <br />
        z tobą
        <br />
        bycie sami ze sobą Translate to english
      </p>
       */}
    </>
  );
}
